// src/index.js — full replacement

import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Auth0Provider
    domain="dev-7ohezt5oz21lioh6.us.auth0.com"
    clientId="zPsWjQrpoIrLw9SmGh0KHHAlf1QwK2Zh"
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: "https://authdungeon-api",
      scope: "openid profile email",
    }}
    cacheLocation="localstorage"
    useRefreshTokens={true}
  >
    <App />
  </Auth0Provider>
);